import { getActiveEmployees } from '@app/reducers/orm/employee/employee.selectors';
import { getActiveShifts } from '@app/reducers/orm/shift/shift.service';
import { getActiveTeams } from '@app/reducers/orm/team/team.service';
import { Store } from '@ngrx/store';
import { AppState } from '@reducers/interfaces';

import type { ReconciliationSource } from './onboarding-draft-schedule.models';

/**
 * Snapshot the created teams / shift templates / employees that reconciliation
 * matches the AI recommendation against. Read from the store the moment
 * reconciliation runs (post-onboarding, so the entities are already loaded).
 */
export function readReconciliationSource(store: Store<AppState>): ReconciliationSource {
  return {
    teams: store
      .selectSignal(getActiveTeams)()
      .map((team) => ({
        id: team.id,
        name: team.name,
        department_id: team.department_id,
      })),
    shifts: store
      .selectSignal(getActiveShifts)()
      .map((shift) => ({
        id: shift.id,
        name: shift.name,
        long_name: shift.long_name,
        department_id: shift.department_id,
        starttime: shift.starttime,
        endtime: shift.endtime,
      })),
    employees: store
      .selectSignal(getActiveEmployees)()
      .map((employee) => ({
        id: employee.id,
        name: employee.name,
        first_name: employee.first_name,
        last_name: employee.last_name,
      })),
  };
}
